import type { GetStaticProps, GetServerSideProps } from "next";
import { ApiService } from "services/server";
import Tab from "views/Tab/Tab";
import {
  normalizeResearchContents,
  normalizeResearchContentsWithDetails,
} from "utils/normalizer";
import { CMS_ENVIRONMENT, ENTITY_ID, REVALIDATE_TIME } from "utils/constants";
import { useEffect, useMemo, useState } from "react";
import { checkEmpty } from "utils/newFunction";

function LibraryPage({ data }) {
  const [tabs, setTabs] = useState([]);
  const [activeTab, setActiveTab] = useState(null);

  useEffect(() => {
    setTabs(data?.tabs || []);
    setActiveTab(data?.tabs?.[0]);
  }, [data?.tabs]);

  const breadcrumb = useMemo(() => {
    if (activeTab) {
      return data?.breadcrumb?.concat({ title: activeTab.tabName });
    }
    return data?.breadcrumb;
  }, [activeTab]);

  const onTabChange = (slug: string) => {
    setActiveTab(tabs?.find?.((item) => item?.slug === slug) || tabs?.[0]);
  };

  const metaTag = data?.metaTag;

  return (
    <Tab
      data={{ ...data, tabs }}
      onTabChange={onTabChange}
      activeTab={activeTab}
      metaTag={metaTag}
      breadcrumb={breadcrumb}
    />
  );
}

// export const getStaticProps: GetStaticProps = async ({ locale }) => {
//   const apiService = new ApiService(locale);
//   const entityId =
//     ENTITY_ID?.[locale?.toUpperCase()]?.[CMS_ENVIRONMENT || "production"]
//       ?.LIBRARY_ID;

//   const requests = [
//     apiService.getContentByEntityId(+entityId), // 0
//   ];

//   const response = await ApiService.multipleRequest(requests);

//   if (checkEmpty(...response)) {
//     throw new Error();
//   }

//   const general = response?.[0]?.[0];

//   const tabsResult = normalizeResearchContentsWithDetails(
//     normalizeResearchContents(general?.researchContents)
//   );

//   let changeLanguageLink = `/library`;
//   changeLanguageLink =
//     locale === "en" ? changeLanguageLink : `/en${changeLanguageLink}`;

//   return {
//     props: {
//       data: {
//         breadcrumb: general?.breadcrumb || [],
//         tabs:
//           tabsResult?.map?.((item) => ({
//             ...item,
//             // changeLanguageLink: item?.changeLanguageLink || changeLanguageLink,
//           })) || [],
//         metaTag: general?.metaTag || {},
//         useDefaultHrefLang: true,
//       },
//     },
//     revalidate: REVALIDATE_TIME,
//   };
// };

export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
  const apiService = new ApiService(locale);
  const entityId =
    ENTITY_ID?.[locale?.toUpperCase()]?.[CMS_ENVIRONMENT]?.LIBRARY_ID ||
    "production";
  try {
    const requests = [
      apiService.getContentByEntityId(+entityId), // 0
    ];
    let response = [];
    try {
      response = await ApiService.multipleRequest(requests);
    } catch (e) {}
    const tabsResult = normalizeResearchContentsWithDetails(
      normalizeResearchContents(response[0]?.[0]?.researchContents)
    );
    const general = response?.[0]?.[0];
    let changeLanguageLink = `/library`;
    changeLanguageLink =
      locale === "en" ? changeLanguageLink : `/en${changeLanguageLink}`;

    return {
      props: {
        data: {
          breadcrumb: general?.breadcrumb || [],
          tabs: tabsResult?.map((item) => ({
            ...item,
            // changeLanguageLink: item?.changeLanguageLink || changeLanguageLink,
          })),
          metaTag: general?.metaTag || {},
          useDefaultHrefLang: true,
        },
      },
    };
  } catch (err) {
    return {
      redirect: {
        destination: "/500",
        permanent: false,
      },
    };
  }
};

export default LibraryPage;
